<template>
  <div>
    <div class="iv-list-study">
      <!--      <p class="iv-list-right-title"><span>列表</span></p>-->
      <div class="iv-list-right-cont">
        <p class="iv-list-li" v-for="item in menuList" :key="item.id" @click="todetail(item)">
          <!--          <Iconfont class="iv-m-r-8 iv-zd" type="zhiding5" v-if="item.orderNum"></Iconfont>-->
          <!--          <Iconfont class="iv-m-r-8" :type="getIcon(item.infoType)"></Iconfont>-->
          <!--        <span class="iv-m-r-8 iv-fc-45 iv-fs-16 iv-fw-6">[{{item.createOrgName}}]</span>-->
          <span class="dot"></span>
          <span class="iv-list-li-title iv-fc-65 iv-fs-14 iv-m-r-24">{{ item.title }}</span>
          <span class="toTop" v-if="item.top>0"></span>
          <span>{{ getTime(item.createTime) }}</span>
        </p>
      </div>
    </div>
    <Page :total="total" :current="currentPage" :pageSize="pageSize" show-sizer show-elevator show-total
          class="iv-list-page" @on-change="changePage" @on-page-size-change="changePageSize"></Page>
  </div>
</template>

<script>

import Iconfont from '@/components/iconfont'
import Page from '@/components/page'
import {timeFormat} from '@/utils'

export default {
  props: ['name', 'id', 'title'],
  data() {
    return {
      menuList: [],
      total: 0,
      current: 1,
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this.initTabs()
  },
  watch: {
    categoryId(val) {
      this.leftData = val
    }
  },
  methods: {
    getIcon(type) {
      if (type == 1) {
        return 'tuwenxinxi'
      } else if (type == 2) {
        return 'tupian'
      } else if (type == 3) {
        return 'shipin1'
      } else if (type == 4) {
        return 'icon-test2'
      } else if (type == 5) {
        return 'he_20zhiduguanli'
      }
    },
    initTabs(keyword) {
      console.log('study>>>>')
      if (keyword) {
        this.title = keyword
      }
      let params = {
        title: this.title,
        // title: '最新[',
        pageSize: this.pageSize,
        pageNum: this.currentPage
      }
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogList',
        method: 'get',
        data: params
      }).then(({data}) => {
        this.menuList = data.rows
        this.total = data.total
        this.$emit('onloaded')
      })
    },
    changePage(page) {
      this.$emit('on-change', page)
      this.current = page
      this.currentPage = page
      this.initTabs()
    },
    changePageSize(page) {
      this.$emit('on-page-size-change', page)
      this.pageSize = page
      this.initTabs()
    },
    getTime(d) {
      return timeFormat(d)
    },
    todetail(item) {
      const {href} = this.$router.resolve({
        name: this.$route.name == 'systemIndex' ? 'zdsyNewsDetail' : 'newsDetail',
        query: {
          infoId: item.id,
          categoryName: item.level1Column.name
        }
      })
      window.open(href, '_blank')
    }
  },
  components: {
    Iconfont,
    Page
  }
}
</script>

<style lang="scss" scoped>
.iv-list-li {
  cursor: pointer;
}

.iv-zd {
  color: #FA2900;
}

.iv-list-right-title {
  height: 57px;
  font-size: 16px;
  line-height: 57px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 9px;

  span {
    display: inline-block;
    height: 57px;
    line-height: 57px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
    border-bottom: 2px solid #2373C8;
    font-size: 16px;
  }
}

.iv-list-right-cont {
  overflow: auto;

  .iv-list-li {
    display: -webkit-box; /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */
    display: -moz-box; /* 老版本语法: Firefox (buggy) */
    display: -ms-flexbox; /* 混合版本语法: IE 10 */
    display: -webkit-flex; /* 新版本语法: Chrome 21+ */
    display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
    -webkit-box-align: center;
    -moz-align-items: center;
    -webkit-align-items: center;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.15);

    .dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #A9E5F9;
      margin-right: 5px;
    }

    .iv-list-li-title {
      -webkit-box-flex: 1;
      -moz-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      font-weight: 400;
    }

    .toTop {
      background: url("~@/assets/images/icon-top.png") no-repeat;
      background-size: 18px;
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 5px;
    }
  }
}
</style>